<template>
    <div class="btn-group" :class="[
         size ? 'btn-group-' + size : '']">
        <ngmm-button
            :icon="item.icon || ''"
            :disabled="item.disabled || false"
            :type="tabCur == item.value ? 'info': 'primary'"
            v-for="(item, index) in initData" :key="index"
            @click.native="handleClick(item.value)">
            {{item.name}}
        </ngmm-button>
    </div>
</template>
<script>
    export default {
        name: 'EButtonGroup',
        props: {
            initData: {
                type: Array,
                required: true,
                default: function () {
                    return [];
                }
            },
            size: String
        },
        data () {
            return {
                tabCur: 0
            };
        },
        methods: {
            handleClick (v) {
                this.tabCur = v;
                this.$emit('eventButtonGroup', v);
            }
        }
    };
</script>

<style rel="stylesheet/less" lang="less" scoped>
</style>





// WEBPACK FOOTER //
// src/plugin-api/packages/button/src/button-group.vue